import ApolloClient from "apollo-boost";
import { InMemoryCache } from "apollo-client-preset";
import { API } from "../config/app";

export const client = new ApolloClient({
  uri: API,
  cache: new InMemoryCache(),
});
